import { ToolCall, Message } from "@me8eon/messages";
import { NameAnd } from "@me8eon/record_utils";
import { AiTool } from "./ai.tools";
import { ErrorsOr, LogAnd } from "@me8eon/errors";

export type AiClientConfig = {
    baseUrl: string;
    model: string;
    apiVersion?: string;
};

export type ToolChoice =
    | "auto"
    | "none"
    | { type: "function"; function: { name: string } };

export type AiStreamEvent =
    | { type: "text-start" }
    | { type: "text-delta"; delta: string; content: string }
    | { type: "text-end"; content: string }
    | { type: "tool-call-start"; toolName: string; toolCallId: string }
    | { type: "tool-call-end"; toolName: string; toolCallId: string }
    | { type: "error"; error: string };

export type AiStreamSink = (event: AiStreamEvent) => void | Promise<void>;

export type AiOptions = {
    model?: string;
    deploymentId?: string;
    temperature?: number;
    maxTokens?: number;
    toolChoice?: ToolChoice;
    tools?: AiTool[];
    customisation?: any;
    response_format?: {
        type: "json_object";
    };
    stream?: {
        sink: AiStreamSink;
    };
};

export type AiClientResult = {
    message: Message;
    toolCalls?: ToolCall[]
};

export type AiClient = (prompt: Message[], options?: AiOptions) => Promise<LogAnd<ErrorsOr<AiClientResult>>>;
export type AiClients = NameAnd<AiClient>;

export function validateAiClientConfig(prefix: string, config: AiClientConfig): string[] {
    const errors: string[] = [];

    if (!config.baseUrl) {
        errors.push(`${prefix}.baseUrl is required`);
    } else if (typeof config.baseUrl !== "string") {
        errors.push(`${prefix}.baseUrl must be a string`);
    }

    if (!config.model) {
        errors.push(`${prefix}.model is required`);
    } else if (typeof config.model !== "string") {
        errors.push(`${prefix}.model must be a string`);
    }

    if (config.apiVersion !== undefined && typeof config.apiVersion !== "string") {
        errors.push(`${prefix}.apiVersion must be a string if provided`);
    }

    return errors;
}